module.exports = __webpack_public_path__ + "img/github.3a152cca.svg";